<div class="vio-login animated fadeIn">

  <!-- Left: Brand panel -->
  <div class="brand-panel">
    <div class="brand-content">
      <div class="brand-logo">
        <div class="logo-circle">
          <svg viewBox="0 0 24 24" fill="white" width="40" height="40" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
        </div>
      </div>
      <h1 class="brand-name">Vio WA Bridge</h1>
      <p class="brand-sub">WhatsApp Business Platform</p>
      <div class="feature-bubbles">
        <div class="bubble bubble-in">
          <span class="bubble-icon">📢</span>
          <div>
            <div class="bubble-title">Campaign Manager</div>
            <div class="bubble-desc">Send targeted WhatsApp campaigns</div>
          </div>
        </div>
        <div class="bubble bubble-out">
          <span class="bubble-icon">⚡</span>
          <div>
            <div class="bubble-title">Flow Builder</div>
            <div class="bubble-desc">Build interactive WhatsApp Forms</div>
          </div>
        </div>
        <div class="bubble bubble-in">
          <span class="bubble-icon">📊</span>
          <div>
            <div class="bubble-title">Delivery Insights</div>
            <div class="bubble-desc">Track delivery, reads &amp; engagement</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right: Form panel -->
  <div class="form-panel">

    <div class="mobile-header">
      <div class="mobile-logo-circle">
        <svg viewBox="0 0 24 24" fill="white" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
        </svg>
      </div>
      <span class="mobile-brand-name">Vio WA Bridge</span>
    </div>

    <div class="form-card">

      <!-- Tab toggle -->
      <div class="tab-toggle">
        <button class="tab-btn" [class.active]="activeTab === 'signin'" (click)="switchTab('signin')">
          Sign In
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'onboard'" (click)="switchTab('onboard')">
          Get Onboarded
        </button>
      </div>

      <!-- ── SIGN IN ── -->
      <ng-container *ngIf="activeTab === 'signin'">
        <h2 class="form-title">Welcome back</h2>
        <p class="form-sub">Sign in to continue to Vio WA Bridge</p>

        <form (ngSubmit)="login()" #loginForm="ngForm">
          <div *ngIf="errorMessage" class="error-msg">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" style="flex-shrink:0">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
            <span>{{ errorMessage }}</span>
          </div>

          <div class="wa-field mb-3">
            <label class="wa-label">Login ID</label>
            <div class="wa-input-wrap">
              <svg class="wa-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              <input class="wa-input" type="text" name="Lid" placeholder="Enter your login ID"
                [(ngModel)]="userName" required autocomplete="username" />
            </div>
          </div>

          <div class="wa-field mb-3">
            <label class="wa-label">Password</label>
            <div class="wa-input-wrap">
              <svg class="wa-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
              </svg>
              <input class="wa-input wa-input-has-eye" [type]="showPassword ? 'text' : 'password'" name="pw"
                placeholder="Enter your password" [(ngModel)]="pwd" required autocomplete="current-password" />
              <button type="button" class="wa-eye-btn" (click)="togglePassword()" tabindex="-1" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                <svg *ngIf="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
                <svg *ngIf="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="wa-field mb-4">
            <label class="wa-label">Client Code</label>
            <div class="wa-input-wrap">
              <svg class="wa-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              <input class="wa-input" type="text" name="clientCode" placeholder="Enter your client code"
                [(ngModel)]="clientCode" required autocomplete="organization" />
            </div>
          </div>

          <button class="btn-wa-signin" type="submit" [disabled]="isLoggingIn">
            <span *ngIf="isLoggingIn" class="signin-spinner"></span>
            <span>{{ isLoggingIn ? 'Signing In...' : 'Sign In' }}</span>
          </button>
        </form>
      </ng-container>

      <!-- ── GET ONBOARDED ── -->
      <ng-container *ngIf="activeTab === 'onboard'">

        <!-- Step: form -->
        <ng-container *ngIf="onboardingStep === 'form'">
          <h2 class="form-title">Connect Your Business</h2>
          <p class="form-sub">Link your WhatsApp Business Account to the platform in minutes.</p>

          <div *ngIf="formError" class="error-msg mb-3">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" style="flex-shrink:0">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
            <span>{{ formError }}</span>
          </div>

          <div class="wa-field mb-3">
            <label class="wa-label">Client Code <span style="color:#e53e3e">*</span></label>
            <div class="wa-input-wrap">
              <svg class="wa-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              <input class="wa-input" type="text" placeholder="e.g. ACME" [(ngModel)]="newClientCode" maxlength="50" />
            </div>
            <div class="wa-hint">Unique identifier for your organisation.</div>
          </div>

          <div class="wa-field mb-4">
            <label class="wa-label">Database Name <span style="color:#e53e3e">*</span></label>
            <div class="wa-input-wrap">
              <svg class="wa-field-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="17" height="17">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4"/>
              </svg>
              <input class="wa-input" type="text" placeholder="e.g. acme_db" [(ngModel)]="newDbName" maxlength="50" />
            </div>
            <div class="wa-hint">MongoDB database name for your data.</div>
          </div>

          <button class="btn-wa-meta" (click)="launchMetaSignup()" [disabled]="!fbInitialized">
            <span *ngIf="!fbInitialized" class="signin-spinner"></span>
            <svg *ngIf="fbInitialized" viewBox="0 0 24 24" fill="currentColor" width="18" height="18" style="flex-shrink:0">
              <path d="M17.525 9H14V7c0-1.032.084-1.682 1.563-1.682h1.868v-3.18A26.065 26.065 0 0 0 14.6 2C11.927 2 10 3.657 10 6.699V9H7v4l3-.001V22h4v-9.003l3.066-.001L17.525 9z"/>
            </svg>
            {{ fbInitialized ? 'Connect via Meta Embedded Signup' : 'Loading Meta SDK…' }}
          </button>
        </ng-container>

        <!-- Step: meta-pending -->
        <ng-container *ngIf="onboardingStep === 'meta-pending'">
          <div class="ob-center">
            <div class="ob-spinner"></div>
            <p class="ob-title">Waiting for Meta…</p>
            <p class="ob-sub">Complete the WhatsApp Business signup in the popup window.</p>
            <button class="btn-wa-link mt-2" (click)="onboardingStep = 'form'">Cancel</button>
          </div>
        </ng-container>

        <!-- Step: confirm -->
        <ng-container *ngIf="onboardingStep === 'confirm'">
          <h2 class="form-title">Review & Confirm</h2>
          <p class="form-sub">Check the details below and save to complete onboarding.</p>

          <div *ngIf="formError" class="error-msg mb-3">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" style="flex-shrink:0">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
            <span>{{ formError }}</span>
          </div>

          <div class="ob-review-table mb-3">
            <div class="ob-row"><span class="ob-key">Client Code</span><span class="ob-val">{{ newClientCode }}</span></div>
            <div class="ob-row"><span class="ob-key">Database</span><span class="ob-val"><code>{{ newDbName }}</code></span></div>
            <div class="ob-row">
              <span class="ob-key">WABA ID</span>
              <input class="wa-input ob-inline-input" [(ngModel)]="capturedWabaId" placeholder="Enter WABA ID" />
            </div>
            <div class="ob-row">
              <span class="ob-key">Phone No ID</span>
              <input class="wa-input ob-inline-input" [(ngModel)]="capturedPhoneNoId" placeholder="Enter Phone No ID" />
            </div>
          </div>

          <div *ngIf="!capturedWabaId || !capturedPhoneNoId" class="warn-msg mb-3">
            WABA ID or Phone Number ID was not captured from Meta. Please enter them manually.
          </div>

          <div class="d-flex gap-2">
            <button class="btn-wa-secondary flex-grow-1" (click)="onboardingStep = 'form'" [disabled]="isSaving">Back</button>
            <button class="btn-wa-signin flex-grow-1" (click)="confirmAndSave()"
              [disabled]="isSaving || !capturedWabaId || !capturedPhoneNoId">
              <span *ngIf="isSaving" class="signin-spinner"></span>
              {{ isSaving ? 'Saving…' : 'Confirm & Save' }}
            </button>
          </div>
        </ng-container>

        <!-- Step: done -->
        <ng-container *ngIf="onboardingStep === 'done'">
          <div class="ob-center">
            <div class="ob-check">✓</div>
            <p class="ob-title">{{ newClientCode }} is Onboarded!</p>
            <p class="ob-sub" *ngIf="confirmedPhone">Phone: <strong>{{ confirmedPhone }}</strong></p>
            <p class="ob-sub" *ngIf="confirmedName">Verified as: <strong>{{ confirmedName }}</strong></p>
            <p class="ob-sub mt-2">Your platform account is ready. Use your credentials to Sign In.</p>
            <button class="btn-wa-signin mt-3" style="width:auto;padding:10px 28px;" (click)="switchTab('signin')">
              Go to Sign In
            </button>
          </div>
        </ng-container>

      </ng-container>

      <div class="salary-confirm-row">
        <button type="button" class="btn-salary-confirm" (click)="goToPage('/salary-confirmation')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="14" height="14">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
          </svg>
          Confirmation on WhatsApp
        </button>
      </div>
      <div class="form-footer">Powered by <a href="https://viotalworks.com/" target="_blank" rel="noopener noreferrer" class="powered-link">Viotal Works Pvt Ltd</a></div>
    </div>
  </div>

</div>
